import {useCallback, useEffect, useMemo, useState} from "react"
import {
    Backdrop,
    BackdropRoot,
    Box,
    Button,
    FormControl, FormControlLabel,
    IconButton,
    Input,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
} from "@mui/material"
import {ArrowBack as ArrowBackIcon, CheckBox, Close as CloseIcon, Refresh as RefreshIcon} from "@mui/icons-material"
import {AgGridReact} from "ag-grid-react"
import UseApiManager from "../../manager/api"
import columnDefs, { defaultColDef } from "./columnDefs"
import PropTypes from "prop-types"
import {ParsePhoneNumber} from "../../manager/util"
import _ from "lodash"
import LOCALE_JA from "../../../resources/aggrid/locale.ja"
import Editor from "./editor"

const styles = {
    rootBox: {
        width: '90%',
        height: '90%',
        background: 'white',
        borderRadius: '1rem',
        boxShadow: '1px 1px 3px #000',
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
    },
    headerBox: {
        display: 'flex',
        alignItems: 'center',
        padding: '1rem',
        background: 'rgb(238, 238, 238)',
        justifyContent: 'space-between',
        borderStyle: 'none none inset none',
        borderColor: '#333',
        borderWidth: '0.5px'
    },
    title: {
        fontSize: '24px',
        fontWeight: 'bold',
        color: '#787878',
        marginLeft: '1rem',
    }
}

export const UserAdminMode = {
    NewUser: "new_user",
    EditUser: "edit_user",
}

const UserAdminView = ({ onClose }) => {

    const [loading, setLoading] = useState()
    const [rowData, setRowData] = useState([])
    const [mode, setMode] = useState(null)
    const [editUser, setEditUser] = useState(null)
    const { Get } = UseApiManager()


    const load = useCallback(() => {
        setLoading(true)
        setRowData([])
        Get("user/list")
            .then(res => {
                setRowData(res)
            })
    }, [])

    const controlRenderer = (param, value) => {
        console.log("control", param, param.value)
        if (!param.data) { return null }
        return (
            <Box>
                <Button size="small" variant="contained">パスワード変更</Button>
                <Button size="small" variant="contained">無効化</Button>
                <Button size="small" variant="contained">編集</Button>
                <Button size="small" variant="contained">削除</Button>
            </Box>
        )
    }

    const webPermissionRenderer = (param) => {
        if (!param.data) { return null }
        if (param.data.permissions?.includes("All")) {
            return "管理権限"
        } else if (param.data.permissions?.includes("WebEdit")) {
            return "編集権限"
        } else if (param.data.permissions?.includes("WebLogin")) {
            return "閲覧権限"
        }

        return "なし"
    }

    const appPermissionRenderer = (param) => {
        if (!param.data) { return null }
        if (param.data.permissions?.includes("All")) {
            return "管理権限"
        } else if (param.data.permissions?.includes("AppEdit")) {
            return "編集権限"
        } else if (param.data.permissions?.includes("AppLogin")) {
            return "閲覧権限"
        }

        return "なし"
    }

    const phoneRenderer = (param) => {
        if (!param.value) { return null }
        let value = param.value.trim()
        value = value
            .replace(/^\+81/, '0')
            .replace(/-/g, '')
        if (!value.match(/^[0-9]+$/)) {
            return null
        }
        return value
    }

        return (
        <Box style={styles.rootBox}>
            <Box style={styles.headerBox}>
                <Typography style={styles.title}>ユーザ管理</Typography>
                <Box>
                    <Button variant="outlined" onClick={() => setMode(UserAdminMode.NewUser)}>新規登録</Button>
                    <IconButton onClick={load}>
                        <RefreshIcon />
                    </IconButton>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </Box>
            <Box style={{flexGrow: 1}}>
                <AgGridReact
                    className="ag-theme-balham"
                    style={{height: "100%"}}
                    localeText={LOCALE_JA}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    rowData={rowData}
                    rowDragManaged={true}
                    components={{
                        controlRenderer,
                        webPermissionRenderer,
                        appPermissionRenderer,
                        phoneRenderer,
                    }}
                />
            </Box>
            <Backdrop open={!!mode} style={{zIndex: 2}}>
                <Editor mode={mode} user={editUser} />
            </Backdrop>
        </Box>
    )

}

UserAdminView.propTypes = {
    onClose: PropTypes.func.isRequired,
}

export default UserAdminView
